/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { Raw } from 'vue'

import { CalendarDate, CalendarDateTime, Time, ZonedDateTime } from '@internationalized/date'
import { markRaw } from 'vue'

// References:
// https://github.com/unovue/reka-ui/issues/1641
// https://github.com/vuejs/core/issues/2981
// https://github.com/vuejs/core/issues/7240

markRaw(CalendarDate.prototype)
markRaw(Time.prototype)
markRaw(CalendarDateTime.prototype)
markRaw(ZonedDateTime.prototype)

declare module '@internationalized/date' {
  type RawBrand = keyof Raw<{}>
  const RawSymbol: RawBrand

  export interface CalendarDate {
    [RawSymbol]?: true
  }

  export interface Time {
    [RawSymbol]?: true
  }

  export interface CalendarDateTime {
    [RawSymbol]?: true
  }

  export interface ZonedDateTime {
    [RawSymbol]?: true
  }
}
